










import { Component, Vue, Prop } from 'vue-property-decorator'
import DeviceBuilder from '@/views/sandbox/builder/device/DeviceBuilder.vue'
import Buttons from '@/views/sandbox/Buttons.vue'
import AppHeader from '@/components/app/AppHeader.vue'
import AppFooter from '@/components/app/AppFooter.vue'
import { ProjectIsGPT } from '@/utils/project'

@Component({
  components: { Buttons, DeviceBuilder, AppHeader, AppFooter },
})
export default class BuilderContainer extends Vue {
  @Prop({ default: false, type: Boolean }) hidden!: boolean

  get isGpt() {
    return ProjectIsGPT()
  }
}
